import { SET_CUSTOMER_SERVICE } from './constants';

export function setCustomerServiceAction(values) {
  return {
    type: SET_CUSTOMER_SERVICE,
    payload: values,
  };
}
